export default "Review on the way ...\n\n<!-- Diana & Rasmus. -->";